import { setFocusOnField } from '@/core/core_components/form/form'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { initDataInList, initDataInTextInput } from '@/core/item_assistance/initializeComponentData'
import { getDataFromTextInput } from '@/core/item_assistance/receiveDataFromComponents'

export function CompanyManager () {
	'use strict'

	this.action = undefined
	this.companyId = undefined
	this.company = undefined
	this.activeAttribute = undefined
	this.fields = undefined
	this.prefix = undefined
	this.admin = undefined

	this.setProperties = function (properties) {
		this.action = properties.action || 'create'
		this.companyId = properties.companyId || null
		this.company = properties.company
		this.activeAttribute = properties.activeAttribute || undefined
		this.fields = properties.fields || ['name', 'gln', 'description', 'valueAddedTax']
		this.prefix = properties.prefix || 'company_'
		this.admin = properties.admin || false
	}

	this.initPage = function () {
		var manager = this

		if (this.action === 'edit') {
			this.setCompanyInformation()
			this.showAndBindDeleteItemsButton()
			this.showAndBindDeleteEnvironmentButton()
			this.showAndBindRecalculateItemStatusesButton()
			this.showAndBindDownloadEnvironmentButton()
			this.showAndBindUploadEnvironmentButton()
			setFocusOnField(this.activeAttribute)

			$('#' + this.prefix + 'users-groups').removeClass('hidden-element')
			$('#' + this.prefix + 'attribute-groups-block').removeClass('hidden-element')
			$('#attribute-config-block').removeClass('hidden-element')
		}

		$('#sidebar_save').click(function () {
			manager.saveCompany()
		})
	}

	this.saveCompany = function () {
		var url = (this.action === 'edit') ? 'company/update' : 'company/create'
		var companyInformation = this.getCompanyInformation()
		var manager = this

		if (this.validateForm(companyInformation)) {
			return false
		}

		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			data: JSON.stringify(companyInformation),
			contentType: 'application/json; charset=UTF-8',

			success: function (newCompanyId) {
				if (manager.action == 'edit') {
					showMessageAlert(getLocalizedMessage('changes.saved'), 'success')
				}
				if (manager.action == 'create') {
					showMessageAlert(getLocalizedMessage('changes.saved'), 'success')
					location.href = '/company/' + newCompanyId
				}
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error.saving'), 'danger')
			}
		})
	}

	this.validateForm = function (companyInformation) {

		let { name, gln, type, role, code, streetAndNumber, city, historyKeepDurationInDays } = companyInformation

		if (_.isEmpty(name)) {
			showMessageAlert(getLocalizedMessage('name.is.required'), 'danger')
			return true
		}
		if (_.isEmpty(gln)) {
			showMessageAlert(getLocalizedMessage('gln.is.required'), 'danger')
			return true
		}
		if (_.isEmpty(streetAndNumber)) {
			showMessageAlert(getLocalizedMessage('streetAndNumber.is.required'), 'danger')
			return true
		}
		if (_.isEmpty(city)) {
			showMessageAlert(getLocalizedMessage('city.is.required'), 'danger')
			return true
		}
		if (_.isEmpty(type)) {
			showMessageAlert(getLocalizedMessage('type.is.required'), 'danger')
			return true
		}
		if (_.isEmpty(role)) {
			showMessageAlert(getLocalizedMessage('role.is.required'), 'danger')
			return true
		}
		if (historyKeepDurationInDays < 0) {
			showMessageAlert(getLocalizedMessage('history.storage.period.cannot.to.negative'), 'danger')
			return true
		}
		if (type !== 'INDIVIDUAL' && _.isEmpty(code)) {
			showMessageAlert(getLocalizedMessage('code.is.required'), 'danger')
			return true
		}

		return false
	}

	this.initDateRecovery = function () {
		var dataRecovery = '#data__recovery'
		var datepicker = $(dataRecovery + '-datepicker')
		var button = $(dataRecovery + '-button')
		var preloader = $(dataRecovery + '-preloader')
		$('#data__recovery-datepicker').datetimepicker({
			format: 'YYYY-MM-DD HH:mm:ss'
		})

		datepicker.val(new Date().toISOString().slice(0, 19).replace('T', ' '))

		button.on('click', function () {
			var date = new Date(datepicker.val()).toISOString().slice(0, -1)

			$.ajax({
				url: window.urlContext + 'items/history/state/apply',
				type: 'POST',
				data: 'date=' + date,
				async: true,
				beforeSend: function () {
					preloader.show()
				},
				success: function (res) {
					preloader.hide()
					showMessageAlert('success', 'success')
				},
				error: function (error) {
					preloader.hide()
					showMessageAlert(error.statusText, 'danger')
				}
			})
		})
	}

	this.setCompanyInformation = function () {
		var manager = this
		_.each(this.company, function (value, key) {
			initDataInTextInput(manager.prefix + key, value)
		})

		$('#' + this.prefix + 'registrationDate').html(this.company['registrationDate'].slice(0, 10))
	}

	this.loadCompanyInformation = function () {
		var manager = this

		$.ajax({
			url: window.urlContext + 'company/get',
			data: { id: manager.companyId },
			cache: false,
			type: 'POST',
			async: false,
			success: function (data) {
				manager.company = data
			}
		})

	}

	this.getCompanyInformation = function () {
		var manager = this
		var companyInformation = {}
		var maxDays = 1825

		if (this.action == 'edit') {
			companyInformation.id = this.companyId
		}

		_.each(this.fields, function (field) {
			companyInformation[field] = getDataFromTextInput(manager.prefix + field)
		})

		if (companyInformation['historyKeepDurationInDays'] > maxDays) {
			companyInformation['historyKeepDurationInDays'] = maxDays
			initDataInTextInput(manager.prefix + 'historyKeepDurationInDays', maxDays)
		}

		if (this.action !== 'create') {
			if (!companyInformation['type']) {
				companyInformation['type'] = this.company.type
			}
			if (!companyInformation['role']) {
				companyInformation['role'] = this.company.role
			}
		}

		return companyInformation
	}

	this.showAndBindDeleteItemsButton = function () {
		var manager = this
		$('#' + this.prefix + 'delete-items-block').removeClass('hidden-element')
		$('#' + this.prefix + 'delete-items').click(function () {
			manager.deleteItems()
		})
	}

	this.showAndBindDeleteEnvironmentButton = function () {
		var manager = this
		var button = $('#' + this.prefix + 'delete-environment')
		var buttonBlock = $('#' + this.prefix + 'delete-environment-block')
		if (button) {
			buttonBlock.removeClass('hidden-element')
			button.click(function () {
				manager.deleteEnvironment()
			})
		}
	}

	this.deleteItems = function () {
		var manager = this
		Swal.fire({
			title: getLocalizedMessage('are.you.sure.you.want.to.delete.all.items'),
			allowOutsideClick: true,
			confirmButtonText: getLocalizedMessage('ok'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			}
		}).then(function (result) {
			if (result.value) {
				$.ajax({
					url: window.urlContext + 'items/delete-all',
					type: 'POST',
					data: { companyId: manager.companyId },
					success: function () {
						showMessageAlert(getLocalizedMessage('all.items.are.removed'), 'success')
					},
					error: function () {
						showMessageAlert(getLocalizedMessage('error'), 'danger')
					}
				})
			}
		})
	}

	this.deleteEnvironment = function () {
		var manager = this
		Swal.fire({
			title: getLocalizedMessage('are.you.sure.you.want.to.delete.environment.company'),
			allowOutsideClick: true,
			confirmButtonText: getLocalizedMessage('ok'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			}
		}).then(function (result) {
			if (result.value) {
				$.ajax({
					url: window.urlContext + '/company/' + manager.companyId + '/environment/delete',
					type: 'POST',
					success: function () {
						showMessageAlert(getLocalizedMessage('environment.company.are.removed'), 'success')
					},
					error: function () {
						showMessageAlert(getLocalizedMessage('error'), 'danger')
					}
				})
			}
		})
	}

	this.showAndBindRecalculateItemStatusesButton = function () {
		var manager = this
		$('#' + this.prefix + 'recalculate-item-statuses-block').removeClass('hidden-element')
		$('#' + this.prefix + 'recalculate-item-statuses').click(function () {
			manager.recalculateItemStatuses()
		})
	}

	this.recalculateItemStatuses = function () {
		var manager = this

		$.ajax({
			url: window.urlContext + 'items/status/recalculate',
			type: 'POST',
			data: { companyId: manager.companyId },
			success: function () {
				showMessageAlert(getLocalizedMessage('item.statuses.successfully.recalculated'), 'success')
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error'), 'danger')
			}
		})
	}

	this.showAndBindDownloadEnvironmentButton = function () {
		var manager = this
		$('#' + this.prefix + 'download-environment-block').removeClass('hidden-element')
		$('#' + this.prefix + 'download-environment').click(function () {
			manager.showDownloadEnvironmentWindow()
		})
	}

	this.showDownloadEnvironmentWindow = function () {
		var manager = this

		Swal.fire({
			title: 'Download Company environment',
			html: '<div class="company-environment">' +
				'<div class="form-check">\n' +
				'    <input class="uk-checkbox" type="checkbox" id="companyEnvironmentAttributes">\n' +
				'    <label class="form-check-label" for="companyEnvironmentAttributes">\n' +
				'        attributes\n' +
				'    </label>\n' +
				'</div>\n' +
				'<div class="form-check">\n' +
				'    <input class="uk-checkbox" type="checkbox" id="companyEnvironmentResources">\n' +
				'    <label class="form-check-label" for="companyEnvironmentResources">\n' +
				'        resources\n' +
				'    </label>\n' +
				'</div>\n' +
				'<div class="form-check">\n' +
				'    <input class="uk-checkbox" type="checkbox" id="companyEnvironmentMigrations">\n' +
				'    <label class="form-check-label" for="companyEnvironmentMigrations">\n' +
				'        migrations\n' +
				'    </label>\n' +
				'</div>\n' +
				'<div class="form-check">\n' +
				'    <input class="uk-checkbox" type="checkbox" id="companyEnvironmentItems">\n' +
				'    <label class="form-check-label" for="companyEnvironmentItems">\n' +
				'        items\n' +
				'    </label>\n' +
				'</div>\n' +
				'<div class="form-check padded">\n' +
				'    <input class="uk-checkbox" type="checkbox" id="companyEnvironmentItemsHistory">\n' +
				'    <label class="form-check-label" for="companyEnvironmentItemsHistory">\n' +
				'        items history\n' +
				'    </label>\n' +
				'</div>\n' +
				'<div class="form-check padded">\n' +
				'    <input class="uk-checkbox" type="checkbox" id="companyEnvironmentAttachments">\n' +
				'    <label class="form-check-label" for="companyEnvironmentAttachments">\n' +
				'        attachments\n' +
				'    </label>\n' +
				'</div>\n' +
				'</div>',
			confirmButtonText: 'download',
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			preConfirm: function () {
				return {
					attributes: document.getElementById('companyEnvironmentAttributes').checked,
					resources: document.getElementById('companyEnvironmentResources').checked,
					migrations: document.getElementById('companyEnvironmentMigrations').checked,
					items: document.getElementById('companyEnvironmentItems').checked,
					history: document.getElementById('companyEnvironmentItemsHistory').checked,
					attachments: document.getElementById('companyEnvironmentAttachments').checked,
				}
			}
		}).then(function (result) {
			if (result.value) {
				var url = '/company/' + manager.companyId + '/environment/download'
				var params = $.param(result.value)
				if (params.indexOf('true') !== -1) {
					$('.progress').show()
					downloadCompanyEnvironment(url + '?' + params).then(function () {
						$('.progress').hide()
					}).catch(function (error) {
						console.log(error)
					})
				} else {
					return false
				}
			}
		})
	}

	this.showAndBindUploadEnvironmentButton = function () {
		var manager = this
		$('#' + this.prefix + 'upload-environment-block').removeClass('hidden-element')
		$('#' + this.prefix + 'upload-environment').click(function () {
			manager.showUploadEnvironmentWindow()
		})
	}

	this.showUploadEnvironmentWindow = function () {
		var manager = this

		Swal.fire({
			title: 'Upload company environment',
			input: 'file',
			inputAttributes: {
				accept: '.zip',
				'aria-label': 'upload.company.environment'
			},
			confirmButtonText: 'upload',
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				content: 'upload-file',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			}
		}).then(function (result) {
			if (result.value) {
				manager.uploadEnvironment(result.value)
			}
		})
	}

	this.uploadEnvironment = function (file) {
		var manager = this

		if (file) {
			var data = new FormData()
			data.append('source', file)

			$.ajax({
				url: window.urlContext + 'company/' + manager.companyId + '/environment/upload',
				data: data,
				cache: false,
				contentType: false,
				processData: false,
				type: 'POST',
				async: false,

				success: function () {
					var modalWindowSelector = $('.modal-window')
					modalWindowSelector.off('hide.bs.modal')
					modalWindowSelector.modal('hide')
					showMessageAlert(getLocalizedMessage('success'), 'success')
				},
				error: function () {
					var modalWindowSelector = $('.modal-window')
					modalWindowSelector.off('hide.bs.modal')
					modalWindowSelector.modal('hide')
					showMessageAlert(getLocalizedMessage('error'), 'danger')
				}
			})
		}
	};
}
